import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import { Rows } from "@ui/table/Rows";
import { GD } from "src/GD";
import { S_ADD_GROUP_POPUP } from "src/view/popup/AddGroupPopup";
import { HBox, VBox } from "@ui/box/Box";
import Spacer from "@ui/spacer/Spacer";
import Button from "@ui/button/Button";
import { S_CLIENT_CREDENTIALS_POPUP } from "src/view/popup/ClientCredentialsPopup";
import { NestedMerchantList } from "./NestedMerchantList";

export interface IClientGroupsProps {
	client_id?: number;
	internal?: boolean;
	hideControls?: boolean;
	variant?: "default" | "portfolio";
}

export const ClientGroups = ({ client_id, internal, hideControls, variant = "default" }: IClientGroupsProps) => {
	useLocale();
	const [groups, _repeat, _clean, _busy] = GD.REQ_API.useRequest(undefined, {
		method: "clients/group/list",
		data: {
			client_id: client_id,
		},
	});

	const onAdd = async () => {
		client_id && S_ADD_GROUP_POPUP.invoke({ groupID: -1, clientID: client_id });
	};

	const websites = (groups?.data ?? []).filter((w: IClientGroup) => w.status !== "deleted");

	return (
		<VBox>
			{variant === "portfolio" ? <NestedMerchantList variant="standalone" merchants={websites} busy={_busy || !groups} error={groups?.error}
				onRetry={() => _repeat({ method: "clients/group/list", data: { client_id } })}
				onOpen={row => S_CLIENT_CREDENTIALS_POPUP.invoke({ merchantID: row.id, clienttID: row.client_id })}
				onEdit={!hideControls && client_id ? row => S_ADD_GROUP_POPUP.invoke({ groupID: row.id, clientID: client_id }) : undefined} /> : <Rows
				itemType="website"
				internal={internal}
				searchable={websites.length > 10}
				busy={!groups}
				data={websites}
				controlsPadding="20px"
				error={groups?.error}
				order={["status", "name", "domain", "risk"]}
				menu={
					hideControls
						? undefined
						: [
								{
									title: msg("edit"),
									id: "edit",
								},
							]
				}
				onMenuClick={
					hideControls
						? undefined
						: (id, row, _rowID) => {
								if (id === "edit") {
									client_id &&
										S_ADD_GROUP_POPUP.invoke({
											groupID: (row as any).id,
											clientID: client_id,
										});
									return;
								}
							}
				}
				onClick={row => {
					S_CLIENT_CREDENTIALS_POPUP.invoke({
						merchantID: (row as any).id,
						clienttID: (row as any).client_id,
					});
					//presenter.navChange("merchant", { id: row.id });
				}}
			/>}
			<Spacer size="30px" />
			{!hideControls && (
				<HBox>
					<Spacer grow />
					<Button onClick={onAdd} title={msg("addGroup")} variant="primarySmall" />
				</HBox>
			)}
		</VBox>
	);
};
